import { Injectable, Signal } from '@angular/core';
import { IAddressData, IAddressModel } from '@partners/api';
import { Observable } from 'rxjs';
import { StateAccessService } from '../../../services';
import { AddressActions, AddressSelectors, IAddressState } from '../store';

@Injectable({
  providedIn: 'root'
})
export class AddressStore extends StateAccessService<IAddressState> {
  readonly state$: Observable<IAddressState>;

  readonly data$$: Signal<IAddressData>;
  readonly model$$: Signal<IAddressModel>;

  constructor() {
    super();

    this.model$$ = this.stateFacade.selectSignal$(AddressSelectors.model);
    this.data$$ = this.stateFacade.selectSignal$(AddressSelectors.data);
  }

  dispatchAddressReset() {
    this.stateFacade.dispatch(AddressActions.reset());
  }
  dispatchUpdateModel({ model }: { model: IAddressModel }) {
    this.stateFacade.dispatch(AddressActions.updateModel({ model }));
  }

  dispatchAddressLoad() {
    this.stateFacade.dispatch(AddressActions.load());
  }
  dispatchAddressLoadSuccess({ model, data }: { model: IAddressModel; data: IAddressData }) {
    this.stateFacade.dispatch(AddressActions.loadSuccess({ model, data }));
  }
  dispatchAddressSubmit() {
    this.stateFacade.dispatch(AddressActions.submit());
  }
  dispatchAddressSubmitSuccess({ model, data }: { model: IAddressModel; data: IAddressData }) {
    this.stateFacade.dispatch(AddressActions.submitSuccess({ model, data }));
  }
}
